<template>
  <div class="chooseBox">
    <div class="chooseLeft">
      <div class="chooseTitle w100 flex jbetween acenter">
        <div class="flex acenter">
          <p>可选项目</p>
          <div class="chooseIcon">
            <el-tooltip class="item" effect="dark" content="可选项目" placement="top">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-tishi"></use>
              </svg>
            </el-tooltip>
          </div>
        </div>

        <el-input
          clearable
          v-model="itemSearch"
          style="width: 150px"
          placeholder="搜索薪资项"
          suffix-icon="el-icon-search"
        />
      </div>
      <div class="chooseCollapse">
        <el-scrollbar>
          <el-collapse v-model="activeNames">
            <el-collapse-item :title="item.type" :name="item.type" v-for="(item,idx) in filterChooseLists"
                              v-bind:key="item.index">
              <div class="chooseLi" v-for="(data,io) in item.chooseList" v-bind:key="data.id"
                   @click="chooseData(idx,io)">
                {{data.itemNameCh}}
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-scrollbar>
      </div>
    </div>
    <div class="chooseRight">
      <div class="chooseTitle">
        <p>展示信息项目</p>
        <div class="chooseIcon">
          <el-tooltip class="item" effect="dark" content="展示信息项目" placement="top">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-tishi"></use>
            </svg>
          </el-tooltip>
        </div>
      </div>
      <div class="chooseDatas">
        <draggable :list="dynamicTags" group="item" @change="log">
          <el-tag
            :key="tag"
            v-for="tag in dynamicTags"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)">
            {{tag.chooseList.itemNameCh}}
          </el-tag>
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
import {deepCopy} from "@/util/util";
import draggable from "vuedraggable";

export default {
  name: "chooseBox",
  components: {
    draggable
  },
  props: {
    dynamicTags: {
      type: Array,
      default() {
        return []
      }
    },
    chooseLists: {
      type: Array,
      default() {
        return []
      }
    },
  },
  watch: {
    dynamicTags: function (newVal, oldVal) {
      this.$emit("update:dynamicTags", true);
    },
    chooseLists: function (newVal, oldVal) {
      this.$emit("update:chooseLists", true);
    },
  },
  data() {
    return {
      activeNames: [],
      itemSearch: ''
    };
  },
  computed: {
    filterChooseLists() {
      this.activeNames = []
      if (this.itemSearch) {
        let tempLists = deepCopy(this.chooseLists)
        return tempLists.filter(group => {
          group.chooseList = group.chooseList.filter(item => item.itemNameCh.includes(this.itemSearch))
          if (group.chooseList.length) {
            setTimeout(() => {
              this.activeNames.push(group.type)
            }, 100)
          }
          return group.chooseList.length
        })
      }
      return this.chooseLists
    }
  },
  methods: {
    chooseData(index, i) {
      console.log("选择的项目----", index, i);
      let group = this.filterChooseLists[index]
      let obj = {};
      obj.index = index;
      obj.chooseList = this.filterChooseLists[index].chooseList[i];
      this.dynamicTags.push(obj);
      this.filterChooseLists[index].chooseList.splice(i, 1);
      // 全部列表里也同步去掉
      console.log(obj)
      this.chooseLists.forEach(item => {
        if (item.id === group.id) {
          console.log(item, group)
          let chooseIndex = 0
          item.chooseList.forEach((chooseItem, index) => {
            if (chooseItem.id === obj.chooseList.id) {
              chooseIndex = index
            }
          })
          console.log(chooseIndex)
          item.chooseList.splice(chooseIndex, 1)
        }
      })
    },
    handleClose(tag) {
      console.log(this.chooseLists)
      console.log(tag)
      let selectItem = tag.chooseList;
      this.chooseLists.forEach(item => {
        if (item.id == selectItem.setId) {
          item.chooseList.push(selectItem)
        }
      }, selectItem)
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    log(evt) {
      console.log(this.dynamicTags)
    },

  }
};
</script>

<style scoped>
</style>
